import React, { useEffect, useState } from "react";
import { getRoomStatusById } from "@/services/common/getRoomStatusById";
import { useNavigate, useParams } from "react-router-dom";
import { Flex } from "antd";
import { Loading } from "@100mslive/roomkit-react";
import ButtonComponent from "@/components/button/Button";
import useTriggerNotification from "@/hooks/useTriggerNotification";

const CallLobby = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isActive, setIsActive] = useState(false);
  const { trigger, element } = useTriggerNotification();
  const isGuest = window.location.pathname?.includes("guest");

  const handleJoinCall = () => {
    getRoomStatusById(id, isGuest ? "guest" : "normal")
      .then((res) => {
        if (res.code !== 403) {
          if (res.roomCode) {
            if (window.location.pathname?.includes("parent")) {
              navigate(`/parent/meeting/${id}/${res.roomCode}`);
            } else {
              navigate(`/meeting/${id}/${res.roomCode}`);
            }
          }
        } else {
          trigger({
            type: "error",
            message: res.message,
          });
        }
      })
      .catch((err) => console.log(err));
  };

  const executeTask = (task) => {
    let delay = 5;
    let finalCounterSecond = 300;
    let currentDelay = delay;

    setTimeout(() => {
      if (currentDelay > finalCounterSecond) return;

      function executeTask() {
        if (currentDelay > finalCounterSecond) return;

        // Execute the task
        task();

        // Schedule the next execution with doubled delay
        if(currentDelay > 15) {
          currentDelay = 15; // Ensure the delay does not exceed 15 seconds
        } else {
          currentDelay += currentDelay;
        }
        // Check if next delay exceeds the maximum delay
        if (currentDelay <= finalCounterSecond) {
          setTimeout(executeTask, currentDelay * 1000); // convert to milliseconds
        }
      }

      // Start the first task execution after the initial delay
      setTimeout(executeTask, currentDelay * 1000);
    });
  };

  const checkRoomStatus = () => {
    executeTask(() => {
      getRoomStatusById(id, isGuest ? "guest" : "normal")
        .then((res) => setIsActive(res.enabled))
        .catch((err) => console.log(err));
    });

    // setTimeout(() => {
    //   delay = delay + delay;
    //   console.log(delay);
    //   if (delay < finalCounterSecond && !isActive) {
    //     // getRoomStatusById(id)
    //     //   .then((res) => setIsActive(res.enabled))
    //     //   .catch((err) => console.log(err));
    //   }
    // }, delay);
  };

  useEffect(() => {
    checkRoomStatus();
  }, [id]);

  return (
    <>
      {element}
      <Flex
        justify="center"
        align="center"
        style={{ height: "300px", paddingBottom: "10px" }}
        vertical
        gap={"40px"}
      >
        <Loading size={100} color="#db5800" />
        <Flex vertical gap={"10px"}>
          <div className="body-b3">Almost there! The host is on their way</div>
          <Flex
            className="add-note"
            style={{
              background: "white",
              marginTop: "1rem",
              padding: "1rem",
              borderRadius: "8px",
              border: "1px solid #E5E5E5",
            }}
          >
            <p>
              <span className="body-b3" style={{ fontWeight: 500 }}>
                Note:
              </span>{" "}
              <span className="body-b3">
                A recording and transcript of the session will be available after it concludes.
              </span>
            </p>
          </Flex>
          <ButtonComponent label="Join Call" disabled={!isActive} onClick={handleJoinCall} />
        </Flex>
      </Flex>
    </>
  );
};

export default CallLobby;
